import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { PropertyCard } from "../components/PropertyCard";
import { Button } from "../components/ui/button";
import { useFavorites } from "../lib/favorites";
import { Heart } from "@phosphor-icons/react";

export default function FavoritesPage() {
  const { list } = useFavorites();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (list.length === 0) { setProperties([]); setLoading(false); return; }
    Promise.all(list.map(id => api.get(`/properties/${id}`).then(r => r.data).catch(() => null)))
      .then(results => setProperties(results.filter(Boolean)))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, [list.join(",")]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="mb-10 flex items-center gap-3">
        <Heart size={32} weight="fill" className="text-[#C8A24A]" />
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#C8A24A] font-semibold">Guardadas</p>
          <h1 className="font-heading text-4xl tracking-tight" data-testid="favorites-title">Mis favoritos</h1>
        </div>
      </div>

      {loading ? (
        <p className="text-[#C8A24A]/70">Cargando...</p>
      ) : properties.length === 0 ? (
        <div className="bg-[#1A1A1A] rounded-2xl border border-dashed border-[#C8A24A]/20 p-16 text-center">
          <Heart size={40} className="mx-auto text-[#C8A24A]/30 mb-4" />
          <p className="font-heading text-2xl mb-2">Aún no guardas propiedades</p>
          <p className="text-sm text-[#C8A24A]/70 mb-6">Marca el ícono de corazón en cualquier propiedad para guardarla.</p>
          <Link to="/propiedades">
            <Button className="bg-[#C8A24A] hover:bg-[#B88C2D] text-[#111111]">Explorar propiedades</Button>
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {properties.map(p => <PropertyCard key={p.id} property={p} />)}
        </div>
      )}
    </div>
  );
}
